import styles from './progress-loader.module.scss';
function ProgressLoader() {
  return (
    <div className={`row justify-content-center`}>
      <div className={'col-12 d-flex justify-content-center '}>
        <div className={`${styles.progress} ${styles.blue}`}>
          <span className={styles['progress-left']}>
            <span className={styles['progress-bar']}></span>
          </span>
          <span className={styles['progress-right']}>
            <span className={styles['progress-bar']}></span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProgressLoader;